// extracted by css-extract-rspack-plugin
export default {"row":"_64dbad83","top":"_8bdc2522","bottom":"_8e03e406","vCenter":"_acedd5f4","left":"_d0b074f2","right":"_d343c089","hCenter":"_9331b1aa"};